
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/shared/AppSidebar';
import { useIsMobile } from '@/hooks/use-mobile';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { LanguageSelector } from '@/components/ui/language-selector';
import { HubSelector } from '@/components/ui/hub-selector';
import { UserMenu } from '@/components/ui/user-menu';
import { useTranslation } from '@/lib/i18n';
import BottomNavigation from './BottomNavigation';
import { NotificationPermission } from '@/components/shared/NotificationPermission';

const MainLayout = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        
        <SidebarInset className="flex-1 w-0 min-w-0">
          {/* Header */}
          <header className="border-b px-4 py-3 flex items-center shadow-sm sticky top-0 z-40 w-full" style={{ background: 'var(--gradient-primary)' }}>
            <SidebarTrigger className="mr-4 text-white hover:bg-white/20" />
            <div className="flex-1">
              {/* Title removed */}
            </div>
            <div className="flex items-center gap-3">
              <LanguageSelector />
              <HubSelector />
              <ThemeToggle />
              <UserMenu />
            </div>
          </header>

          {/* Main Content */}
          <main className="flex-1 p-4 pb-20 md:pb-4 overflow-auto w-full max-w-full">
            <NotificationPermission />
            <div className="animate-fade-in w-full">
              <Outlet />
            </div>
          </main>
        </SidebarInset>
      </div>

      {/* Mobile Bottom Navigation */}
      {isMobile && <BottomNavigation />}
    </SidebarProvider>
  );
};

export default MainLayout;
